/**
 * Created by julio perez on 10/19/2016.
 */

class MapLeafletService {
    constructor(){

        let vm = this;
        vm.mapData = null;
        vm.segmentData = null;

        vm.markers = [];
        vm.zoom = 2;

        // here's the SVG for the marker
        vm.icon = "<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='10' height='10'><rect width='5' height='5' stroke='blue' stroke-width='1' d='M 0,0 L 10,10 M 10,0 L 0,10 Z'/></svg>";

        // here's the trick, base64 encode the URL
        vm.svgURL = "data:image/svg+xml;base64," + btoa(vm.icon);


        vm.dIcon = L.divIcon({
            className: 'div-icon',
            iconSize: [5,5]
        });


        // create icon
        vm.SVGIcon = L.icon( {
            iconUrl: vm.svgURL,
            iconSize: [10, 10],
            shadowSize: [12, 10],
            iconAnchor: [5, 5],
            popupAnchor: [5, -5]
        } );

        // vm.map = new L.Map("map", {
        //     attributionControl: false,
        //     zoomControl: false,
        //     dragging: false,
        //     scrollWheelZoom:false,
        //     doubleClickZoom: false,
        //     boxZoom: false,
        //     center: new L.LatLng(28.0902, 100.7129),
        //     zoomSnap: .25,
        //     zoom: 1.5
        // });


        vm.map = new L.Map("map", {
            attributionControl: true,
            zoomControl: true,
            dragging: true,
            scrollWheelZoom:true,
            doubleClickZoom: true,
            boxZoom: true,
            center: new L.LatLng(22.1583, 2.9638),
            zoomSnap: .25,
            zoom: 1.5,
            minZoom: 1.5,
            maxZoom: 3.5
        });

        vm.map.invalidateSize();
        vm.maxBounds = vm.map.getBounds();

        vm.wMap = require("../../services/data/geoMapFeatures.json");

        // L.tileLayer.provider('CartoDB.Positron').addTo(vm.map);
        L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy;<a href="https://carto.com/attribution">CARTO</a>',
            noWrap: false,
            continuousWorld: false
        }).addTo(vm.map);
        L.Projection.Mercator;

        vm.map.setMaxBounds(vm.maxBounds);

        console.log("leaflet:: ", vm.mapData);

        // vm.bounds = vm.map.getBounds();
        // vm.map.fitBounds(vm.bounds);

        // vm.z = vm.map.getZoom();
        //
        // vm.map.setZoom(vm.z);
        // vm.map.on('zoomend', update);
        //
        // update();

        function update() {

            console.log(vm.map.fitBounds(vm.bounds));
            console.log(vm.z);

            // var largestSide = Math.max(bounds[1][0] - bounds[0][0],
            //         bounds[1][1] - bounds[0][1]) / 40;
            // var zoomLevel = map.getZoom();
            // rects.style('stroke-width', largestSide / zoomLevel);


        }

        // vm.blueIcon = L.icon({
        //     iconUrl: 'http://commscdn.euromonitor.com/WTM-2016/images/map_marker_blue.png',
        //     shadowUrl: 'http://commscdn.euromonitor.com/WTM-2016/images/map_marker_blue_shadow.png',
        //     iconSize: [40,40],
        //     shadowSize: [40,40],
        //     iconAnchor: [25, 25],
        //     shadowAnchor: [25,25],
        //     popupAnchor: [-5, -15]
        // })
        //
        // vm.popOps =  {
        //     'maxWidth': '400',
        //     closeButton: false,
        //     'className': 'popOps'
        // }

        // vm.createMarker=(item, index)=>{
        //
        //     var marker =  new L.marker(item.latlng, {icon: vm.dIcon, title: item.country})
        //         .bindPopup(vm.getPop(item.country, item.latlng ), vm.popOps);
        //
        //     marker.id = item.country;
        //     marker.name = item.country;
        //     vm.markers.push(marker);
        //     vm.map.addLayer(marker);
        //
        //     return marker;
        // }
        //
        // vm.getPop=(countryName, location)=>{
        //
        //
        //     return "<h6 class='pop-section'>" + countryName.toUpperCase() + "</h6>" + "<h4 class='pop-country'>" + location + "</h4>";
        //
        // }



    }


    createMarkers(){


        let vm = this;

        vm.mapData.forEach(vm.createMarker);
        vm.displayMarker();

    }


    // createMarker(id){
    //     let vm = this;
    //
    //     var marker =  new L.marker(getLocation(id), {icon: vm.dIcon, title: id})
    //         .addTo(vm.map)
    //         .bindPopup(getPop(id), vm.popOps);
    //     return marker;
    // }

    getMap(){
        let vm = this;
        return vm.map;
    }







    init(){
        console.log('init')
    }



}








export default angular
    .module('mapLeafletService', [])
    .service('mapLeafletService', MapLeafletService)
    .name;


// WEBPACK FOOTER //
// ./src/app/views/map-page/map.leaflet.js